import { render } from "./InfoSectionComponent.vue?vue&type=template&id=d966a45a&scoped=true"
import script from "./InfoSectionComponent.vue?vue&type=script&lang=js"
export * from "./InfoSectionComponent.vue?vue&type=script&lang=js"

import "./InfoSectionComponent.vue?vue&type=style&index=0&id=d966a45a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d966a45a"]])

export default __exports__